import * as types from './mutation-types'
import {LOAD_CARD_STATUS} from "./mutation-types";

export const loadCards = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/cards/collection', data).then((response) => {
            commit(types.LOAD_CARDS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const loadCardStatus = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/cards/status/enum').then((response) => {
            commit(types.LOAD_CARD_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createCards = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/card', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateCards = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/card/'+ data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeStatus = ({ commit }, { id, data }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`change/card/${id}/status`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const assignCard = ({ commit }, data ) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`assign/card`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const returnCards = ({ commit }, id ) => {
    return new Promise((resolve, reject) => {
        window.axios.get('return/card/'+ id)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteCards = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/card').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getCardConfig = ({ commit }, cardId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/cards/${cardId}/configurations`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setCardConfig = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/cards/${data.id}/configurations`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadAssignCard = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/assign/to/door', data).then((response) => {
            commit(types.LOAD_ASSIGNED_CARD, response.data.users)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}